import ChatCache from "./ChatCache";

// Open-rate A/B experiment.
//
// The hotel picks a mode in the backoffice (assistant chat configuration):
//   "A"     — force the classic widget for everyone (current default)
//   "B"     — force the proactive widget for everyone
//   "split" — 50/50 split by visitor fingerprint (measures both arms on the
//             same traffic)
//
// For now the default is "A" (classic): the proactive arm only shows where a
// hotel is explicitly set to "B" or "split". We'll flip the default to the
// proactive variant later. In split mode the variant is derived from the
// persistent visitor fingerprint (uuid4 in localStorage): last hex digit
// even => A, odd => B. Deterministic across sessions and page loads.
export type Variant = "A" | "B";
export type VariantMode = "A" | "B" | "split";

let variantMode: VariantMode = "A";

// Called by Chat.tsx as soon as the assistant chat configuration arrives.
// Anything tracked before that uses the default "A" assignment, which matches
// the backend default — only forced B/split hotels could ever see a pre-config
// event mislabeled, and Chat gates the impression on config load.
export function setVariantMode(mode: any) {
  if (mode === "A" || mode === "B" || mode === "split") variantMode = mode;
}

export function getVariant(): Variant {
  if (variantMode === "A" || variantMode === "B") return variantMode;
  try {
    const fingerprint: string = new ChatCache().getFingerprint() ?? "";
    const lastHex = parseInt(fingerprint.replace(/-/g, "").slice(-1), 16);
    if (isNaN(lastHex)) return "A";
    return lastHex % 2 === 0 ? "A" : "B";
  } catch {
    // No localStorage (privacy mode edge cases): fall back to control.
    return "A";
  }
}
